import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppService } from '@base/app.service';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.sass']
})
export class CustomerComponent implements OnInit, OnDestroy {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private mainService: AppService,
  ) { }

  ngOnInit() {
    const loginAsActivated = this.mainService.isLoginAs;

    // console.log(`Es LoginAs ... ${loginAsActivated}`);
    this.route.data.subscribe(
      (response) => {
        // console.log(response);
        // const data: IHomeDataSet = response['data'];

        // if (data !== null) {
        //   this.mainService.setCurrentUser(data.user);
        //   this.mainService.setCurrentCompany(data.company);
        //   this.loadCustomerTags(data.user, data.company);
        // } else {
        //   this.router.navigate(['']);
        // }
      },
      // (e: HttpErrorResponse) => {const err: IErrorResponse = this.exceptionService.errorHandling(e); }
    );

    if (loginAsActivated) {
      // localStorage.removeItem('company');
      // this.mainService.removeSession();
      // this.router.navigate(['/home/']);
    }
  }

  ngOnDestroy() {
  }
}
